<template>
    <section
        :style="commonConfigStyles"
        class="o-path-steps-otg"
    >
        <header class="path-steps-otg-header">
            <span class="path-steps-otg-header-title">
                {{ headerTitle }}
            </span>
            <OGuideSwitch
                v-if="commonConfigParams.guideSwitch"
                v-model="pathMode"
            />
        </header>
        <div class="path-steps-otg-container">
            <OPathStepsItemOtg
                v-for="step in guideSteps"
                :key="step.idx"
                :item="item"
                :step="step"
                :isOutdoorItem="isOutdoorItem"
                :shouldShowGmapStep="shouldShowGmapStep"
                @onClick="onStepClick"
            />
        </div>
    </section>
</template>

<script>
import {
    mapState,
    mapGetters
} from "vuex";

import OGuideSwitch from '../../organisms/o-guide-switch';
import OPathStepsItemOtg from '../../organisms/o-path-steps-item-otg';

import { EASY } from "../../../utils/constants/app-constants";
import {
    UI_MAP_READY,
    UI_STEP_BY_STEP_DIRECTIONS
} from '../../../shared/components/map-viewer/constants/map-events';
import { TERMINAL_ID_CHANGED } from "../../../utils/constants/bus-events-constants";
import { MAP_SHOW_PATH } from '../../../shared/components/map-viewer/constants/map-commands';

export default {
    name: 'OPathStepsOtg',
    components: {
        OGuideSwitch,
        OPathStepsItemOtg
    },
    data() {
        return {
            pathMode: 'easy'
        }
    },
    props: {
        itemId: {
            type: Number,
            required: true
        },
        view: {
            type: String,
            default: ''
        }
    },
    computed: {
        ...mapGetters([
            't',
            'isAppLoaded',
            'getTerminalId',
            'getMapLoading',
            'getMapConfigProp',
            'getTerminalConfig',
            'getDenormalisedObjectById'
        ]),
        ...mapState({
            activePath: state => state.activePath,
            activeStepIndex: state => state.activeStepIndex
        }),
        item() {
            return this.getDenormalisedObjectById(this.itemId);
        },
        guideSteps() {
            return this.activePath?.steps?.map((el, idx) => {
                const isActive = idx === this.activeStepIndex;
                const isLastStep = idx === this.activePath?.steps?.length - 1 || false;

                return {
                    ...el,
                    idx,
                    isActive,
                    stepIndicator: idx + 1,
                    isLastStep
                }

            }) || [];
        },
        headerTitle() {
            return this.pathMode === EASY
                ? this.$t('ui.directions-for-wheelchairs')
                : this.$t('ui.show-fastest-way');
        },
        commonConfigParams() {
            return this.getMapConfigProp('components.OPathStepsOtg.params') || { guideSwitch: false};
        },
        commonConfigStyles() {
            return this.getMapConfigProp('components.OPathStepsOtg.styles') || null;
        },
        isOutdoorItem() {
            return this.t(this.item, 'is_google_maps') || false;
        },
        shouldShowGmapStep() {
            return this.t(this.item, 'should_show_gmap_step') || false;
        }
    },
    mounted() {
        this.initEventListeners();
    },
    beforeDestroy() {
        this.deactivateEventListeners();
    },
    watch: {
        pathMode: {
            handler() {
                this.buildPath();
            }
        },
        '$route.params.mode': {
            handler(value) {
                this.pathMode = value;
            },
            deep: true,
            immediate: true
        }
    },
    methods: {
        initEventListeners() {
            this.$bus.$on(UI_STEP_BY_STEP_DIRECTIONS, this.setActivePath);
            this.$bus.$on(TERMINAL_ID_CHANGED, this.buildPath);
        },
        deactivateEventListeners() {
            this.$bus.$off(UI_STEP_BY_STEP_DIRECTIONS, this.setActivePath);
            this.$bus.$off(TERMINAL_ID_CHANGED, this.buildPath);
        },
        setActiveStepIndex(index) {
            this.$store.commit('setActiveStepIndex', index);
        },
        onStepClick(stepIndex) {
            this.setActiveStepIndex(stepIndex);
            this.$bus.$emit("map:showPathSteps", stepIndex);
        },
        buildPath() {
            if(!this.item) return;
            this.setActiveStepIndex(null);

            const params = {
                from:{
                    id: this.getTerminalId
                },
                to: {
                    id: this.itemId
                },
                mode: this.pathMode,
            };
            if( _.has(this.getTerminalConfig, 'cameras.kiosk_orientation'))
                params.initial_orientation = this.getTerminalConfig.cameras.kiosk_orientation;

            // eslint-disable-next-line camelcase
            if(this.item?.meta?.prioritise_outdoor)
                params.use_outside = 'prefer'

            params.portal_rules = this.getMapConfigProp('guide.portal_rules', {});

            this.$bus.$emit(MAP_SHOW_PATH, params);
        },
        setActivePath(data) {
            this.$store.commit('setActivePathToState', data);
        }
    }
}
</script>

<style lang="scss" src="./theme.scss" />